export default __webpack_public_path__ + "static/media/upload-capture.1f4397ec.svg";